/**
 * Persisted user location in localStorage.
 * Hydrates Redux on startup; invalid/corrupt values are treated as missing.
 */

import { LocationData } from "../components/feature/LocationSelector/types";
import { DEFAULT_LOCATION, USER_LOCATION_STORAGE_KEY } from "./constants";
import { isValidLocation } from "./locationHelper";

const parseStoredLocation = (raw: string | null): LocationData | null => {
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw) as Partial<LocationData>;
    if (!isValidLocation(parsed)) {
      return null;
    }
    if (typeof parsed.address !== "string") {
      return null;
    }
    return {
      lat: parsed.lat as number,
      lng: parsed.lng as number,
      address: parsed.address,
    };
  } catch {
    return null;
  }
};

export const locationStorage = {
  getLocation: (): LocationData | null => {
    return parseStoredLocation(localStorage.getItem(USER_LOCATION_STORAGE_KEY));
  },

  setLocation: (location: LocationData): void => {
    localStorage.setItem(USER_LOCATION_STORAGE_KEY, JSON.stringify(location));
  },

  clearStoredLocation: (): void => {
    localStorage.removeItem(USER_LOCATION_STORAGE_KEY);
  },

  /** Stored location if valid, otherwise the app default. */
  getInitialLocation: (): LocationData => {
    return locationStorage.getLocation() ?? { ...DEFAULT_LOCATION };
  },
};
